var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"corpyrights"},[_vm._v("© 2017 - 2026 "+_vm._s(_vm.appName)+" All rights reserved")])}
var staticRenderFns = []

export { render, staticRenderFns }